(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"), require("Redux"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM", "Redux"], factory);
	else if(typeof exports === 'object')
		exports["AzSearch"] = factory(require("React"), require("ReactDOM"), require("Redux"));
	else
		root["AzSearch"] = factory(root["React"], root["ReactDOM"], root["Redux"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_35__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition